import { ArrowRightOutlined } from '@ant-design/icons';
import { Button, TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import dayjs from 'dayjs';
import { MatrialFilterFormValuesPaginated } from 'features/master/components/master-filter-form';
import { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { getRoute } from 'routes/utils';
import { VehicleLog } from 'types/vehicle';
type LoadingTableProps = {
    isListLoading: boolean;
    vehicleList: VehicleLog[];
    itemsCount: number;
    tableParams: MatrialFilterFormValuesPaginated;
    updateParams: Dispatch<SetStateAction<MatrialFilterFormValuesPaginated>>;
    setUserEditData: any;
    setShowAppUserModal: any;
    onApproveReject: any;
    onRefresh :  () => void ;
     isFetching : boolean ;
};
export const LoadingLogTable = ({
    vehicleList,
    isListLoading,
    itemsCount,
    tableParams,
    updateParams,
    onRefresh ,
    isFetching
}: LoadingTableProps) => {
    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<VehicleLog> | SorterResult<VehicleLog>[]
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            order_by: Array.isArray(sorter)
                ? undefined
                : sorter.order === 'ascend'
                    ? 'name'
                    : '-name',
        });
    };
    
     const navigate = useNavigate()
          const handleNigate = (item: any) => {                  
              navigate(getRoute(ROUTES.LOG_ADMIN_DETAIL, item.entryId));    
          }
          
return (
        <>
            <StyledTableWrapper>
                <StyledTableHeader>
                    <RecordCountBadge text={'Loading'} count={itemsCount} />
                     <Button
                        type="link"                // 👈 makes it look like blue text
                        onClick={onRefresh}
                        loading={isListLoading}
                        style={{ padding: 0, marginBottom: 16 }}
                        >
                        Refresh Data
                        </Button>
                </StyledTableHeader>

                <Table<VehicleLog>
                    loading={(isListLoading || isFetching) && { indicator: <TableLoader /> }}
                    dataSource={vehicleList}
                    rowKey="id"
                    onChange={handleTableChange}
                    pagination={{
                        current: tableParams.page,
                        defaultPageSize: tableParams.size,
                        total: itemsCount,
                    }}
                >
                    <Column
                        key="detail"
                        title=""
                        dataIndex="detail"
                        render={() => (
                            <ArrowRightOutlined style={{ cursor: "pointer", fontSize: 16 }} />
                        )}
                        onCell={(record) => {
                            return {
                                style: { cursor: "pointer" }, // ensures cursor shows on hover
                                onClick: () => {
                                    const selection = window?.getSelection()?.toString();
                                    if (!selection?.length) {
                                        handleNigate(record); // ✅ navigate to details
                                    }
                                },
                            };
                        }}
                    />
                    <Column<VehicleLog> title={'Material Name'} dataIndex={'materialName'} />
                    <Column<VehicleLog> title={'Driver Name'} dataIndex={'driverName'} />
                    <Column<VehicleLog> title={'Vehicle Number'} dataIndex={'vNumber'} />
                    <Column<VehicleLog> title={'Expected Weight'} dataIndex={'expectedWeight'} />   
                     <Column<VehicleLog>
                            title="Actual Weight"
                            dataIndex="netWeight"
                            render={(_, record: any) =>
                                record?.netWeight && record.netWeight !== 0 ? record.netWeight : "-"
                            }
                            />
                    <Column<VehicleLog> title={'Difference'} dataIndex={'weightDifference'} />  
                    <Column<VehicleLog> title={'Weight Type'} dataIndex={'weightType'} />
                    {/* <Column<VehicleLog> title={'Entry Weight'} dataIndex={'entryWeight'} />
                    <Column<VehicleLog> title={'Exit Weight'} dataIndex={'exitWeight'} render={(_, record: any) =>
    record?.exitWeight && record.exitWeight !== 0 ? record.exitWeight : "-"
  }/> */}


                    <Column<VehicleLog>
                        title="Loading Date"
                        dataIndex="loadingDate" // or "vInTime", depending on your field
                        render={(value: string | undefined) => (
                            <span>{value ? dayjs(value).format("DD-MM-YYYY") : '-'}</span>
                        )}
                    />
                </Table>
            </StyledTableWrapper>
        </>
    );
};
